import React, { useEffect } from "react";
import { Card, Collapse, Typography, Space, Row, Col, Divider } from "antd";
import {
  PhoneOutlined,
  EnvironmentOutlined,
  MailOutlined,
} from "@ant-design/icons";
import AddressType from "features/Enums/AddressType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import {
  faFax,
  faBuildingShield,
  faGlobe,
  faPhone,
  faPhoneAlt,
  faPhoneFlip,
  faPhoneSquare,
  faEnvelope,
  faHashtag,
  faLocation,
  faMapMarked,
  faLocationArrow,
  faLocationDot,
  faUser,
  faBuilding,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { GetClientByIdApi } from "../ClientsApi";
import { FormattedMessage, useIntl } from "react-intl";

function ClientInfo() {
  const { Text } = Typography;
  const { Panel } = Collapse;
  const dispatch = useDispatch();
  const { id } = useParams();
  const client = useSelector((state) => state.clients.clientListById);
  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );
  useEffect(() => {
    if (id) {
      dispatch(GetClientByIdApi(id));
    }
  }, [id, dispatch]);
  return (
    <>
      <Row>
        <Col span={24}>
          <Row gutter={16} className="new-comp-info">
            <Col xs={24} sm={24}>
              {((client?.isResidential &&
                (client?.alternateName ||
                  client?.alternatePhone ||
                  client?.alternateEmail)) ||
                client?.isCommercial) && (
                <Card size="small" className="clientview-new mb-10">
                  {client?.isResidential ? (
                    <>
                      <h5 style={{ fontWeight: 600 }}>
                        Alternative Contact info
                      </h5>
                      <p>
                        <FontAwesomeIcon icon={faUser} />
                        &nbsp;{client?.alternateName}
                      </p>

                      <p className="mt-5px">
                        <FontAwesomeIcon icon={faEnvelope} />
                        &nbsp;{client?.alternateEmail}
                      </p>
                      <p className="mt-5px">
                        <FontAwesomeIcon icon={faPhoneSquare} />
                        {client?.alternatePhone
                          ? `${client?.countryCode} ${
                              client?.alternatePhone?.length === 10
                                ? client?.alternatePhone?.replace(
                                    /(\d{3})(\d{3})(\d{4})/,
                                    "$1-$2-$3"
                                  )
                                : client?.alternatePhone
                            }`
                          : ""}
                      </p>
                    </>
                  ) : client?.isCommercial ? (
                    <>
                      <h5 style={{ fontWeight: 600 }}>
                        <FormattedMessage id="ClientDetails.CompanyInfo" />
                      </h5>
                      <p>
                        <FontAwesomeIcon icon={faBuilding} />{" "}
                        {client?.companyName}
                      </p>

                      <p className="mt-5px">
                        <FontAwesomeIcon icon={faGlobe} />{" "}
                        {client?.companyWebsite}
                      </p>

                      <p className="mt-5px">
                        <FontAwesomeIcon icon={faPhoneSquare} />
                        {client?.companyPhone
                          ? `${client?.companyCountryCode} ${
                              client?.companyPhone?.length === 10
                                ? client?.companyPhone?.replace(
                                    /(\d{3})(\d{3})(\d{4})/,
                                    "$1-$2-$3"
                                  )
                                : client?.companyPhone
                            }`
                          : ""}
                      </p>
                      <p className="mt-5px">
                        <FontAwesomeIcon icon={faEnvelope} />
                        &nbsp; {client?.companyEmail}
                      </p>
                      <p className="mt-5px">
                        <FontAwesomeIcon icon={faHashtag} />
                        &nbsp; {client?.gstHstnumber}
                      </p>
                      <p className="mt-5px">
                        <FontAwesomeIcon icon={faHashtag} />
                        &nbsp; {client?.qstNumber}
                      </p>
                    </>
                  ) : null}

                  {client?.isCommercial && (
                    <>
                      <Collapse
                        expandIconPosition="end"
                        bordered={false}
                        size="small"
                        className="mt-10"
                      >
                        {/* Main Contact Info */}
                        <Panel
                          header={<strong>Main Contact Info</strong>}
                          key="1"
                        >
                          <p>
                            <FontAwesomeIcon icon={faUser} /> &nbsp;
                            {client?.name}
                          </p>
                          <p className="mt-5px">
                            <FontAwesomeIcon icon={faEnvelope} /> &nbsp;
                            {client?.email}
                          </p>
                          <p className="mt-5px">
                            <FontAwesomeIcon icon={faPhoneSquare} /> &nbsp;
                            {client?.phone
                              ? `${client?.countryCode} ${
                                  client?.phone?.length === 10
                                    ? client?.phone?.replace(
                                        /(\d{3})(\d{3})(\d{4})/,
                                        "$1-$2-$3"
                                      )
                                    : client?.phone
                                }`
                              : ""}
                          </p>
                        </Panel>

                        {/* Billing Contact Info */}
                        <Panel
                          header={<strong>Billing Contact Person</strong>}
                          key="2"
                        >
                          <p>
                            <FontAwesomeIcon icon={faUser} /> &nbsp;
                            {client?.billingCpname}
                          </p>
                          <p className="mt-5px">
                            <FontAwesomeIcon icon={faPhoneSquare} /> &nbsp;
                            {client?.billingCpphone
                              ? `${client?.countryCode} ${
                                  client?.billingCpphone?.length === 10
                                    ? client?.billingCpphone?.replace(
                                        /(\d{3})(\d{3})(\d{4})/,
                                        "$1-$2-$3"
                                      )
                                    : client?.billingCpphone
                                }`
                              : ""}
                          </p>
                        </Panel>

                        {/* Accounting Contact Info */}
                        <Panel
                          header={<strong>Accounting Contact Info</strong>}
                          key="3"
                        >
                          <p>
                            <FontAwesomeIcon icon={faUser} /> &nbsp;
                            {client?.alternateName}
                          </p>
                          <p className="mt-5px">
                            <FontAwesomeIcon icon={faEnvelope} /> &nbsp;
                            {client?.alternateEmail}
                          </p>
                          <p className="mt-5px">
                            <FontAwesomeIcon icon={faPhoneSquare} /> &nbsp;
                            {client?.alternatePhone
                              ? `${client?.countryCode} ${
                                  client?.alternatePhone?.length === 10
                                    ? client?.alternatePhone?.replace(
                                        /(\d{3})(\d{3})(\d{4})/,
                                        "$1-$2-$3"
                                      )
                                    : client?.alternatePhone
                                }`
                              : ""}
                          </p>
                        </Panel>
                      </Collapse>
                    </>
                  )}
                </Card>
              )}
              <Card
                size="small"
                title={<FormattedMessage id="ClientDetails.Address" />}
                className="clientview-new"
              >
                <Row gutter={[8, 8]} wrap>
                  {client?.address?.map((address, index) => (
                    <Col xs={24} key={index}>
                      <p>
                        <FontAwesomeIcon icon={faLocationDot} />
                        &nbsp;
                        {address.isBilling ? (
                          <strong>
                            <FormattedMessage id="ClientDetails.BillingAddress" />
                          </strong>
                        ) : (
                          <>
                            <strong>
                              <FormattedMessage id="ClientDetails.CompanyAddress" />
                            </strong>
                            {address.addressType ===
                              AddressType.CompanyAddress.id && (
                              <span
                                style={{
                                  background: "#1890ff",
                                  color: "#fff",
                                  borderRadius: 4,
                                  padding: "2px 8px",
                                  fontSize: 12,
                                  marginLeft: 8,
                                }}
                              >
                                <FormattedMessage id="ClientInfo.PrimaryAddress" />
                              </span>
                            )}
                          </>
                        )}
                      </p>
                      <span>
                        {[
                          address.address1,
                          address.address2,
                          address.city,
                          addressProvinces.find(
                            (p) => p.id === address?.provinceId
                          )?.provinceNameEn,
                          addressCountries.find(
                            (c) => c.id === address?.countryId
                          )?.countryNameEn,
                          address.zip,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </span>
                    </Col>
                  ))}
                  {client?.createdDate && (
                    <p style={{ marginTop: 16 }}>
                      {<FormattedMessage id="AddClient.ClientSince" />} -{" "}
                      {dayjs(client.createdDate).format("DD MMM YYYY")}
                    </p>
                  )}
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default ClientInfo;
